import {Injectable} from '@angular/core';
import {HttpService} from '@service/http/http.service';
import {endpoints} from '../../../configs/endpoints/endpoint';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SaleTaskService {

  constructor(
    private http: HttpService
  ) {
  }

  getTaskDetail(id: number): Observable<any> {
    return this.http.post(endpoints.crm.saleTasks.detail, {taskId: id});
  }

  getMyTasks(): Observable<any> {
    return this.http.get(endpoints.crm.saleTasks.myTasks);
  }

  getAssignedTasks(): Observable<any> {
    return this.http.get(endpoints.crm.saleTasks.assigned);
  }

  getCompletedTasks(): Observable<any> {
    return this.http.get(endpoints.crm.saleTasks.completed);
  }

  getAllCustomerTasks(customerId: number): Observable<any> {
    return this.http.get(endpoints.crm.saleTasks.ofCustomer(customerId));
  }

  setTaskCompleted(taskId: number, formValue: any): Observable<any> {
    return this.http.post(endpoints.crm.saleTasks.completeTask, {taskId, ...formValue});
  }

  saveTask(taskId: number, formValue: any): Observable<any> {
    return this.http.post(endpoints.crm.saleTasks.edit, {taskId, ...formValue});
  }
}
